import {calculateFuelConsumed} from '../form/properties/fuel-chart/fuel-calculation.utils';
import {POIStationEntry} from '../form/model/poi-station.entry';
import {UntypedFormGroup} from '@angular/forms';
import {PoiGroupType} from '../../../poi/poi-group/poi-group-type';
import {AuthStorage} from '../../../../../core/auth/auth-storage';
import {TachoType} from '../../../monitor/tacho/model/tacho-type';
import {FuelingPoiEntry} from '../../../../../core/component/fueling-poi/model/fueling-poi.entry';
import {ProTasksRoutePrice} from '../form/model/pro-tasks-route-price';

const CRT_CARDLESS_ID = -11;

export class ProTaskManagerUtilsComponent {

  public static getAddressText(address: string, searchText: string, isAddressesEnabled: boolean): string {
    if (isAddressesEnabled) {
      return this.isNotBlank(address) ? address : searchText;
    }
    return searchText;
  }

  public static calculateRouteCost(
    averageFuelPrice: number,
    averageTruckRentPrice: number,
    fuelUsageFor100km: number,
    duration: number,
    totalCost: number,
    distance: number,
    markedRoadsTolls: number): ProTasksRoutePrice {

    if (averageFuelPrice != null && averageTruckRentPrice != null) {
      const distanceInKm = distance != null ? distance / 1000 : 0;
      const durationInHours = duration != null ? duration / 3600 : 0;
      const totalTollsCost = totalCost != null ? totalCost : 0;
      const markedRoadsTollsCost = markedRoadsTolls != null ? markedRoadsTolls : 0;
      const fuelConsumed = calculateFuelConsumed(distanceInKm, fuelUsageFor100km);
      let totalPrice = fuelConsumed * averageFuelPrice
        + durationInHours * averageTruckRentPrice
        + totalTollsCost
        + markedRoadsTollsCost;
      return new ProTasksRoutePrice(
        totalPrice,
        fuelConsumed * averageFuelPrice,
        durationInHours * averageTruckRentPrice,
        totalTollsCost,
        markedRoadsTollsCost
      );
    }
    return null;
  }

  public static calculatePlanningDistance(forms: UntypedFormGroup[]) {
    return forms
            .map(form => form.controls.distance.value)
            .reduce((a, b) => a + b);
  }

  public static resolveFuelIcon(poiStation: FuelingPoiEntry) {
    if (poiStation.contactless) {
      return 'assets/img/proTasks/markers/fuelStations/cardlessStation.svg'
    } else if (poiStation.priceGroup != null) {
      return `assets/img/proTasks/markers/fuelStations/${poiStation.priceGroup}.svg`
    }
    return `assets/img/proTasks/markers/fuelStations/fuelStation.svg`;
  }

  public static getDefaultTachoType(): string {
    let mapConfigs = AuthStorage.getMapConfigs();
    if (mapConfigs != null) {
      return mapConfigs.showTachoTableFirst ? TachoType.TABLE : TachoType.CHART;
    }
    return TachoType.CHART;
  }

  private static isNotBlank(address: string) {
    return address != null && address.length > 0;
  }

  public static getPoiType(type: PoiGroupType) {
    if (type === PoiGroupType.PARKING) {
      return 'REST';
    } else if (type === PoiGroupType.FUEL_STATION) {
      return 'FUELLING';
    } else {
      return null;
    }
  }

}
